(ns ncr.common.ocr)

(def TEXTRACT-MIME-TYPES
  #{"image/png" "image/jpeg" "image/tiff" "application/pdf"})

(def mime-type-supported? TEXTRACT-MIME-TYPES)
